import { __awaiter } from "tslib";
import { createSlice } from '../context';
import { createParser } from '../parser';
import { createTimer } from '../timing';
import { remarkCtx } from './init';
import { marksCtx, nodesCtx, schemaCtx, SchemaReady } from './schema';
export const parserCtx = createSlice(() => null, 'parser');
export const parserTimerCtx = createSlice([], 'parserTimer');
export const ParserReady = createTimer('ParserReady');
export const parser = (pre) => {
    pre.inject(parserCtx).inject(parserTimerCtx, [SchemaReady]).record(ParserReady);
    return (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        yield ctx.waitTimers(parserTimerCtx);
        const nodes = ctx.get(nodesCtx);
        const marks = ctx.get(marksCtx);
        const remark = ctx.get(remarkCtx);
        const schema = ctx.get(schemaCtx);
        const children = [
            ...nodes.map((node) => (Object.assign(Object.assign({}, node), { is: 'node' }))),
            ...marks.map((mark) => (Object.assign(Object.assign({}, mark), { is: 'mark' }))),
        ];
        const spec = Object.fromEntries(children.map(({ id, parser, is }) => [id, Object.assign(Object.assign({}, parser), { is, key: id })]));
        ctx.set(parserCtx, createParser(schema, spec, remark));
        ctx.done(ParserReady);
    });
};
//# sourceMappingURL=parser.js.map